var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41858",
    "data-name": "Group 41858",
    transform: "translate(7279 -22754)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15764",
    "data-name": "Rectangle 15764",
    width: 20,
    height: 20,
    transform: "translate(-7279 22754)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "folder",
    d: "M13.2,4.1H9.582L7.482,2H4.8A2.8,2.8,0,0,0,2,4.8v8.4A2.8,2.8,0,0,0,4.8,16h8.4A2.8,2.8,0,0,0,16,13.2V6.9A2.8,2.8,0,0,0,13.2,4.1ZM3.4,13.2V4.8A1.4,1.4,0,0,1,4.8,3.4H6.9L9,5.5h4.2a1.4,1.4,0,0,1,1.4,1.4h-7A2.8,2.8,0,0,0,4.8,9.7v4.9A1.4,1.4,0,0,1,3.4,13.2Z",
    transform: "translate(-7278.002 22754.998)",
    fill: "#1564e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFilled);
export default __webpack_public_path__ + "static/media/folder-filled.18d39af6e4e412ba82b30810fd1197bc.svg";
export { ForwardRef as ReactComponent };